<!-- components/image-uploader.component.html -->
<div class="max-w-xl mx-auto p-4 bg-white dark:bg-gray-800 rounded-2xl shadow-lg">
    <h2 class="text-xl font-semibold text-gray-800 mb-6 dark:text-white">Upload Media</h2>
    <!-- File Input -->
    <label class="block mb-6">
      <span class="sr-only">Choose images to upload</span>
      <input
        type="file"
        accept="image/*"
        multiple
        (change)="onFilesSelected($event)"
        class="block w-full text-sm text-gray-600 dark:text-gray-300
               file:mr-4 file:py-3 file:px-6
               file:rounded-full file:border-0
               file:text-sm file:font-semibold
               file:bg-blue-50 dark:file:bg-gray-700
               file:text-primary dark:file:text-blue-300
               hover:file:bg-blue-100 dark:hover:file:bg-gray-600
               transition"
      />
    </label>
  
    <!-- Upload Button -->
    <button
      (click)="upload()"
      [disabled]="!files.length"
      class="w-full mb-6 px-5 py-3
             bg-gray-800 hover:bg-gray-900 focus:ring focus:ring-blue-300
             text-white font-medium rounded-xl dark:bg-gray-400 hover:dark:bg-gray-300 dark:text-gray-900
             disabled:opacity-50 disabled:cursor-not-allowed
             transition">
      Upload Selected Images
    </button>
  
    <!-- Progress Bar -->
    <div *ngIf="uploading" class="mb-6">
      <p class="text-sm text-gray-700 dark:text-gray-300 mb-2">
        Uploading {{ progress }} / {{ files.length }}
      </p>
      <div class="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2.5 overflow-hidden">
        <div
          class="h-2.5 bg-blue-600 dark:bg-blue-500 rounded-full"
          [style.width.%]="(progress / files.length) * 100"
        ></div>
      </div>
    </div>
  
    <!-- Results List -->
    <div *ngIf="results.length" class="space-y-4">
      <div
        *ngFor="let res of results"
        class="flex items-center justify-between
               bg-gray-100 dark:bg-gray-700
               p-4 rounded-xl shadow-inner"
      >
        <div class="flex-1 truncate">
          <p class="text-sm font-medium text-gray-900 dark:text-gray-100">
            {{ res.fileName }}
          </p>
        </div>
        <div class="flex space-x-3">
          <a
            [href]="res.largeUrl"
            target="_blank"
            class="text-xs font-semibold text-blue-600 dark:text-blue-400 hover:underline"
          >
            800×800
          </a>
          <a
            [href]="res.smallUrl"
            target="_blank"
            class="text-xs font-semibold text-blue-600 dark:text-blue-400 hover:underline"
          >
            200×200
          </a>
        </div>
      </div>
    </div>
  </div>